module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "InviteMenu__wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "InviteMenu__container"
  }, [(!_vm.contacts.length) ? _c('div', {
    staticClass: "InviteMenu__empty-result-box"
  }, [_vm._v("\n      You have no contacts.\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.contacts), function(user) {
    return _c('div', {
      staticClass: "InviteMenu__user-row"
    }, [_c('img', {
      directives: [{
        name: "fallback-src",
        rawName: "v-fallback-src",
        value: ('../../../../static/images/default-user-avatar.jpg'),
        expression: "'../../../../static/images/default-user-avatar.jpg'"
      }],
      staticClass: "InviteMenu__user-avatar",
      attrs: {
        "src": user.avatarUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "InviteMenu__user-info"
    }, [_c('div', {
      staticClass: "InviteMenu__name"
    }, [_vm._v("\n          " + _vm._s(user.contactName) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "InviteMenu__username"
    }, [_vm._v("\n          @" + _vm._s(user.username) + "\n        ")])]), _vm._v(" "), _c('div', {
      staticClass: "InviteMenu__user-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.checked),
        expression: "user.checked"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'check_user_' + user.userId
      },
      domProps: {
        "checked": Array.isArray(user.checked) ? _vm._i(user.checked, null) > -1 : (user.checked)
      },
      on: {
        "change": [function($event) {
          var $$a = user.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(user, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(user, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(user, "checked", $$c)
          }
        }, function($event) {
          _vm.check(user)
        }]
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form-value",
      attrs: {
        "for": 'check_user_' + user.userId
      }
    }, [_c('i', {
      staticClass: "icon-ic_tick-small InviteMenu__user-checkbox-icon"
    }), _vm._v(" "), _c('i', {
      staticClass: "icon-ic_plus InviteMenu__user-checkbox-icon"
    })])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "InviteMenu__footer"
  }, [_c('div', {
    staticClass: "InviteMenu__invite-btn",
    class: {
      'invalidate': !_vm.checked.length
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n      invite\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "InviteMenu__header"
  }, [_c('i', {
    staticClass: "InviteMenu__header-icon"
  }), _vm._v("\n    Invite via URL\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06f77fc6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/room/invite-menu/invite-menu.vue
// module id = 416
// module chunks = 1